/**
 * A friendly default event name from an uploaded file's name: drop the
 * extension and turn separators into spaces (e.g. "palm-beach_classic.pdf" ->
 * "palm beach classic"). Returns "" when nothing usable is left.
 */
export function deriveEventName(fileName: string): string {
  const withoutExt = fileName.replace(/\.[^./\\]+$/, '');
  return withoutExt.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
}
